import { NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";

export class baseSearchModel {
    DateFrom:  string;
    DateTo: string;
    PageNo: number;
    PageSize: number;
}